import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { repositoriesByIdSelector } from 'state/selectors/repositories';

const useSelectedRepo = service => {
  const repositories = useSelector(repositoriesByIdSelector);
  const [selectedRepo, setSelectedRepo] = useState(null);

  const serviceId = _.get(service, 'id');

  const setInitRepoFromService = () => {
    const firstRepoId = _.get(
      service,
      'settings.path_strategy[0].repository_id'
    );
    const repository = _.get(repositories, firstRepoId, null);
    setSelectedRepo(repository);
  };

  useEffect(() => {
    if (serviceId) setInitRepoFromService();
  }, [serviceId]);

  return [selectedRepo, setSelectedRepo];
};

export default useSelectedRepo;
